import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Dashboard from "../pages/dashboard/page";
import CampaignManagement from "../pages/campaigns/page";
import Visitors from "../pages/visitors/page";
import EventLogs from "../pages/events/page";
import FunnelAnalysis from "../pages/funnel/page";
import LeadManagement from "../pages/leads/page";
import TrafficSources from "../pages/traffic/page";
import UtmAnalysis from "../pages/utm/page";
import Reports from "../pages/reports/page";
import RealtimeActivity from "../pages/realtime/page";
import Settings from "../pages/settings/page";

const routes: RouteObject[] = [
  { path: "/", element: <Dashboard /> },
  { path: "/kampanyalar", element: <CampaignManagement /> },
  { path: "/ziyaretciler", element: <Visitors /> },
  { path: "/event-kayitlari", element: <EventLogs /> },
  { path: "/funnel", element: <FunnelAnalysis /> },
  { path: "/leadler", element: <LeadManagement /> },
  { path: "/trafik", element: <TrafficSources /> },
  { path: "/utm", element: <UtmAnalysis /> },
  { path: "/raporlar", element: <Reports /> },
  { path: "/canli", element: <RealtimeActivity /> },
  { path: "/ayarlar", element: <Settings /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
